/**
 * Suivi horaire : « Meslien WILLIAM » — nom en casse titre d’abord, prénom en majuscules.
 */
export function formatHourlyTrackingWorkerName(firstname, lastname) {
  const rawFn = String(firstname ?? "").trim();
  const rawLn = String(lastname ?? "").trim();

  const titleCaseWord = (word) =>
    word.length === 0
      ? ""
      : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

  const fn = rawFn.toUpperCase();

  const ln = rawLn
    .split(/\s+/)
    .filter(Boolean)
    .map(titleCaseWord)
    .join(" ");

  if (fn && ln) return `${ln} ${fn}`;
  if (ln) return ln;
  if (fn) return fn;
  return "";
}
